import { Box, IconButton, Stack, Tooltip } from "@mui/material"
import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import QuestionIcon from "@mui/icons-material/QuestionMarkOutlined"
import { CASE_STATUS } from "@/modules/Patient/config/status.config"
import { useMyNavigation } from "@/hooks/useMyNavigation"

export const CaseStatusBox = () => {
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { curCaseMode } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const navigate = useMyNavigation()
  let statusMessageMap = new Map<string, string>([
    [CASE_STATUS.COMPLETE_PATIENT_RECORDS, "Please add photos & x-ray"],
    [
      CASE_STATUS.ATTENTION_NEEDED,
      "Attention is needed, please submit stl, photo and/or rx form.",
    ],
    [
      CASE_STATUS.SUBMITTED_TO_UASSIST,
      "Case is submitted to uAssist, waiting review Tx plan.",
    ],
    [CASE_STATUS.SUBMIT_TO_UASSIST, "Rx is done, please submit to uAssist"],
    [CASE_STATUS.FILL_OUT_RX_FORM, "Please fill Rx form and submit to uAssist"],
    [
      CASE_STATUS.REVIEW_PLAN,
      "Tx plan is ready to review, modification & order.",
    ],
    [
      CASE_STATUS.MODIFICATION_REQUESTED,
      "New modification is submitted to uAssist, waiting review modification.",
    ],
    [
      CASE_STATUS.REVIEW_MODIFICATION,
      "Modificatioin is aredy to review & order.",
    ],
    [
      CASE_STATUS.ORDER_SUBMITTED,
      "Order is submitted, waiting production & shipping.",
    ],
    [CASE_STATUS.TREATMENT_IN_PROGRESS, "Treatment is in progress."],
  ])

  const mapStatusToMessage = (status: string) => {
    let msg = statusMessageMap.get(status)
    if (msg == undefined) {
      msg = "Not sure ...."
    }
    return msg
  }
  return (
    <Tooltip
      placement="bottom"
      title={mapStatusToMessage(caseDetail.caseDisposition)}
      arrow
    >
      <Stack
        sx={{
          color: "#000",
          fontFamily: "Poppins",
          fontSize: "15px",
          fontStyle: "normal",
          height: "48px",
          fontWeight: "600",
          letterSpacing: "0.46px",
          backgroundColor: "lightskyblue",
          boxShadow: 2,
          borderRadius: 1,
          paddinptg: "2px",
          display: "flex",
          justifyContent: "space-between",
        }}
        direction={"row"}
      >
        <Box sx={{ minWidth: "200px" }}>
          <Box sx={{}} textAlign={"center"}>
            Status:
          </Box>
          <Box
            sx={{ overflow: "hidden", textOverflow: "clip" }}
            textAlign={"center"}
          >
            {caseDetail.caseDisposition}
          </Box>
        </Box>
      </Stack>
    </Tooltip>
  )
}
